import axios from 'axios';
import { getItem } from '../../utility/localStorageControl';
import { API_ENDPOINT, authHeader } from './dataService';

export const extranetClient = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
});

class ExtranetService {
  static get(path = '', optionalHeader = {}) {
    return extranetClient({
      method: 'GET',
      url: path,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return extranetClient({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {},optionalHeader = {}) {
    return extranetClient({
      method: 'PATCH',
      url: path,
      // data: JSON.stringify(data),
      data,
      headers: { ...authHeader(),...optionalHeader },
    });
  }

  static put(path = '', data = {},optionalHeader = {}) {
    return extranetClient({
      method: 'PUT',
      url: path,
      // data: JSON.stringify(data),
      data,
      headers: { ...authHeader(),...optionalHeader},
    });
  }

  static delete(path = '', data = {}) {
    return extranetClient({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

extranetClient.interceptors.response.use(
  response => response,
  error => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    const originalRequest = error.config;
    if (response) {
      if (response.status === 500) {
        // do something here
      } else {
        return originalRequest;
      }
    }
    return Promise.reject(error);
  },
);

export { ExtranetService };